import { Button, Flex, Input } from "@chakra-ui/react";
import React, { useState } from "react";

interface TextInputProps {
  filterKey: string;
  label: string;
  updateFilter: (filterKey: string, value: any) => void;
  defaultValue?: any;
}

function TextInput({
  filterKey,
  label,
  updateFilter,
  defaultValue,
}: TextInputProps) {
  const [value, setValue] = useState(defaultValue ?? "");

  return (
    <Flex gap={2}>
      <Input
        type="text"
        onChange={(e) => setValue(e.target.value)}
        value={value}
        placeholder={label}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            updateFilter(filterKey, value);
          }
        }}
      />
      <Button
        borderRadius={8}
        colorScheme={"whatsapp"}
        onClick={() => updateFilter(filterKey, value)}
      >
        Apply
      </Button>
    </Flex>
  );
}

export default TextInput;
